"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingWithdrawPenaltyButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const dialogs_1 = require("../../../../dialogs");
const StakingWithdrawPenaltyButton = (props) => {
    const { className, contract: { id, address, accessControls }, contract, disabled, variant, } = props;
    const { openViewDialog } = (0, dialogs_1.useGlobalDialogViewCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const handleWithdrawPenalty = () => {
        openViewDialog(dialogs_1.GlobalDialogKeys.STAKING_WITHDRAW_PENALTY, contract, {
            message: "dialogs.withdrawPenalty",
            componentProps: {
                data: { id, address },
            },
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleWithdrawPenalty, icon: icons_material_1.PriceChange, message: "form.buttons.withdrawPenalty", className: className, dataTestId: "WithdrawPenaltyButton", disabled: disabled || !hasPermission, variant: variant }));
};
exports.StakingWithdrawPenaltyButton = StakingWithdrawPenaltyButton;
//# sourceMappingURL=index.js.map